// Announcement bar rotation
const items = document.querySelectorAll('.announce-item');
if (items.length > 0) {
  let current = 0;
  setInterval(() => {
    items[current].classList.remove('active');
    current = (current + 1) % items.length;
    items[current].classList.add('active');
  }, 3500);
}

// Sticky header transitions
const headerWrap = document.getElementById('headerWrap');
let lastScrollTop = 0;
let scrollThreshold = 10; // min scroll to trigger change

if (headerWrap) {
  window.addEventListener('scroll', () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollDiff = scrollTop - lastScrollTop;

    if (Math.abs(scrollDiff) > scrollThreshold) {
      // Scrolling down and past header height
      if (scrollTop > lastScrollTop && scrollTop > 200) {
        headerWrap.classList.add('header-hide');
      } 
      // Scrolling up
      else if (scrollTop < lastScrollTop) {
        headerWrap.classList.remove('header-hide');
      }
      lastScrollTop = scrollTop;
    }

    // Always show if near top
    if (scrollTop < 50) {
      headerWrap.classList.remove('header-hide');
    }

    // Trigger transition to top (remove 36px offset)
    const isScrolled = scrollTop > 20;
    headerWrap.classList.toggle('scrolled', isScrolled);
    
    if (headerWrap.classList.contains('transparent')) {
      headerWrap.classList.toggle('header--solid', isScrolled);
    }
  }, { passive: true });
}

// Profile dropdown
const profileBtn = document.getElementById('profileBtn');
const profileDropdown = document.getElementById('profileDropdown');

if (profileBtn && profileDropdown) {
  profileBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    profileDropdown.classList.toggle('show');
  });

  window.addEventListener('click', () => {
    if (profileDropdown.classList.contains('show')) {
      profileDropdown.classList.remove('show');
    }
  });

  profileDropdown.addEventListener('click', (e) => e.stopPropagation());
}

// Mobile sidebar – accordion style
const sidebar = document.getElementById('sidebar');
const sidebarOverlay = document.getElementById('sidebarOverlay');
const sidebarBtn = document.getElementById('sidebarBtn');
const sidebarClose = document.getElementById('sidebarClose');

const openSidebar = () => {
  sidebar.classList.add('open');
  sidebar.removeAttribute('aria-hidden');
  sidebarOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
};
const closeSidebar = () => {
  sidebar.classList.remove('open');
  sidebar.setAttribute('aria-hidden', 'true');
  sidebarOverlay.classList.remove('open');
  document.body.style.overflow = '';
};

if (sidebarBtn)     sidebarBtn.addEventListener('click', openSidebar);
if (sidebarClose)   sidebarClose.addEventListener('click', closeSidebar);
if (sidebarOverlay) sidebarOverlay.addEventListener('click', closeSidebar);

// Sidebar accordions — generic handler, works for any .sidebar-acc-btn
document.querySelectorAll('.sidebar-acc-btn').forEach(btn => {
  const body = btn.nextElementSibling;
  if (!body || !body.classList.contains('sidebar-acc-body')) return;
  btn.addEventListener('click', () => {
    const isOpen = body.classList.contains('open');
    body.classList.toggle('open');
    btn.setAttribute('aria-expanded', String(!isOpen));
  });
});


// Search
const searchBtn = document.getElementById('searchBtn');
const searchOverlay = document.getElementById('searchOverlay');
const searchClose = document.getElementById('searchClose');
const searchInput = document.getElementById('searchInput');
if (searchBtn && searchOverlay && searchClose && searchInput) {
  searchBtn.addEventListener('click', () => {
    searchOverlay.classList.add('open');
    setTimeout(() => searchInput.focus(), 100);
  });
  searchClose.addEventListener('click', () => searchOverlay.classList.remove('open'));
  searchOverlay.addEventListener('click', (e) => {
    if (e.target === searchOverlay) searchOverlay.classList.remove('open');
  });
}

// Esc key handling
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    if (searchOverlay) searchOverlay.classList.remove('open');
    closeSidebar();
    const dropdown = document.getElementById('dropdown');
    if (dropdown) dropdown.classList.remove('open');
    const popupOverlay = document.getElementById('popupOverlay');
    if (popupOverlay) popupOverlay.classList.remove('open');
  }
});

// Theme toggle
const themeToggle = document.getElementById('themeToggle');
if (themeToggle) {
  themeToggle.addEventListener('click', () => {
    const html = document.documentElement;
    html.dataset.theme = html.dataset.theme === 'dark' ? 'light' : 'dark';
    localStorage.setItem('theme', html.dataset.theme);
  });
}

// Initialize theme from localStorage
const savedTheme = localStorage.getItem('theme');
if (savedTheme) {
  document.documentElement.dataset.theme = savedTheme;
}

// Cupcake popup
const cupcakeBtn = document.getElementById('cupcakeBtn');
const popupOverlay = document.getElementById('popupOverlay');
const popupClose = document.getElementById('popupClose');
if (cupcakeBtn && popupOverlay && popupClose) {
  cupcakeBtn.addEventListener('click', () => popupOverlay.classList.add('open'));
  popupClose.addEventListener('click', () => popupOverlay.classList.remove('open'));
  popupOverlay.addEventListener('click', (e) => {
    if (e.target === popupOverlay) popupOverlay.classList.remove('open');
  });
}

// Back to top
const backToTop = document.getElementById('backToTop');
if (backToTop) {
  backToTop.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
